import React from 'react';

import {Box, Stack, Skeleton} from 'views/components';


const LoadingSkeleton = (props) => {
  return (
    <Stack>
      {/* CareQuilt Header */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          gap: 1,
          m: {xs: 1, md: 2},
        }}
      >
        <Skeleton
          variant="rectangular"
          sx={{
            width: {xs: 24, sm: 32, md: 40},
            height: {xs: 24, sm: 32, md: 40},
            borderRadius: 1,
          }}
        />
        <Skeleton
          variant="text"
          sx={{
            width: '175px',
            height: {xs: 24, sm: 32, md: 40},
          }}
        />
      </Box>
      <Skeleton
        variant="rectangular"
        width="100%"
        height={2}
      />
      {/* Form Section */}
      <Stack
        alignItems="center"
        sx={{
          width: '100%',
          minHeight: '100vh',
          position: 'relative',
          pb: '100px',
        }}
      >
        <Stack
          spacing={{
            xs: 2,
            md: 3,
            lg: 3.5,
          }}
          sx={{
            width: {
              xs: '100%',
              md: '80%',
              lg: '66%',
              xl: '50%',
            },
            mx: 'auto',
            my: {
              xs: 2,
              md: 3,
              lg: 3.5,
            },
          }}
        >
          {/* Happiness Score Card Skeleton 1 */}
          <Box
            sx={{
              bgcolor: 'color.white',
              borderRadius: '12px',
              p: 3,
            }}
          >
            <Skeleton variant="text" width="60%" height={30} sx={{mb: 2}} />
            <Stack direction="row" spacing={2}>
              <Skeleton
                variant="rectangular"
                sx={{
                  width: '100%',
                  height: 120,
                  borderRadius: '12px',
                }}
              />
              <Skeleton
                variant="rectangular"
                sx={{
                  width: '100%',
                  height: 120,
                  borderRadius: '12px',
                }}
              />
              <Skeleton
                variant="rectangular"
                sx={{
                  width: '100%',
                  height: 120,
                  borderRadius: '12px',
                }}
              />
            </Stack>
          </Box>

          {/* Happiness Score Card Skeleton 2 */}
          <Box
            sx={{
              bgcolor: 'color.white',
              borderRadius: '12px',
              p: 3,
            }}
          >
            <Skeleton variant="text" width="60%" height={30} sx={{mb: 2}} />
            <Stack direction="row" spacing={2}>
              <Skeleton
                variant="rectangular"
                sx={{
                  width: '100%',
                  height: 120,
                  borderRadius: '12px',
                }}
              />
              <Skeleton
                variant="rectangular"
                sx={{
                  width: '100%',
                  height: 120,
                  borderRadius: '12px',
                }}
              />
              <Skeleton
                variant="rectangular"
                sx={{
                  width: '100%',
                  height: 120,
                  borderRadius: '12px',
                }}
              />
            </Stack>
          </Box>

          {/* Improvement Card Skeleton */}
          <Box
            sx={{
              bgcolor: 'color.white',
              borderRadius: '12px',
              p: 3,
            }}
          >
            <Skeleton variant="text" width="70%" height={30} />
            <Stack spacing={1} sx={{mt: 2}}>
              <Skeleton variant="rectangular" width="100%" height={40} />
              <Skeleton variant="rectangular" width="100%" height={40} />
              <Skeleton variant="rectangular" width="100%" height={40} />
            </Stack>
            <Skeleton variant="rectangular" width="100%" height={100} sx={{mt: 2}} />
          </Box>

          {/* Privacy Checkbox Skeleton */}
          <Box
            sx={{
              bgcolor: 'color.white',
              borderRadius: '12px',
              p: 2,
            }}
          >
            <Skeleton variant="text" width="80%" height={24} />
          </Box>
        </Stack>
      </Stack>
      {/* Footer Skeleton */}
      <Stack
        bgcolor="color.white"
        sx={{
          width: '100%',
          position: 'fixed',
          left: 0,
          bottom: 0,
          zIndex: 1200,
          boxShadow: '0 -2px 8px rgba(0,0,0,0.06)',
        }}
      >
        <Skeleton variant="rectangular" width="100%" height={2} />
        <Stack
          alignItems="center"
          spacing={1}
          sx={{
            width: '100%',
            px: 6,
            py: 2,
          }}
        >
          <Skeleton
            variant="rectangular"
            width="100%"
            height={56}
            sx={{
              borderRadius: '12px',
            }}
          />
          <Skeleton variant="text" width="60%" height={20} />
        </Stack>
      </Stack>
    </Stack>
  );
};

LoadingSkeleton.propTypes = {

};

export default React.memo(LoadingSkeleton);
